import { PERMISSION_TO_DISPLAY_NAME } from "@src/features/libraryItem/course/shareButton/constants";
import Text from "@src/lib/ui/Text";
import useIsFullAdmin from "@src/features/app/hooks/useIsFullAdmin";
import { SharingPermission } from "@src/types.generated";
import { FC, useMemo } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@src/lib/ui/Select";

type Props = {
  allAdminsSelection: SharingPermission;
  onSetAllAdminsSelection: (newPermission: SharingPermission) => void;
  allManagersSelection: SharingPermission;
  onSetAllManagersSelection: (newPermission: SharingPermission) => void;
  commentOptionEnabled?: boolean;
  viewPermissionEnabled?: boolean;
  disabled?: boolean;
};

const GeneralAccessSection: FC<Props> = ({
  allAdminsSelection,
  onSetAllAdminsSelection,
  allManagersSelection,
  onSetAllManagersSelection,
  commentOptionEnabled = true,
  viewPermissionEnabled = false,
  disabled = false,
}) => {
  const isFullAdmin = useIsFullAdmin();
  const adminOptions = useMemo(() => {
    const options = [SharingPermission.Edit];
    if (commentOptionEnabled) options.push(SharingPermission.Comment);
    if (viewPermissionEnabled) options.push(SharingPermission.ViewInLibrary);
    return options;
  }, [commentOptionEnabled, viewPermissionEnabled]);

  const managerOptions = useMemo(() => {
    const options = [SharingPermission.Edit];
    if (commentOptionEnabled) options.push(SharingPermission.Comment);
    if (viewPermissionEnabled) options.push(SharingPermission.ViewInLibrary);
    options.push(SharingPermission.None);
    return options;
  }, [commentOptionEnabled, viewPermissionEnabled]);

  if (!isFullAdmin) {
    return null;
  }
  return (
    <div className="flex flex-col gap-3">
      <Text type="P3" fontWeight="SemiBold">
        General collaborators
      </Text>
      <div className="flex items-center justify-between">
        <Text type="P2">All Admins</Text>
        <Select
          value={allAdminsSelection}
          onValueChange={(val) =>
            onSetAllAdminsSelection(val as SharingPermission)
          }
          disabled={disabled}
        >
          <SelectTrigger className="w-[120px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {adminOptions.map((p) => (
              <SelectItem key={p} value={p}>
                {PERMISSION_TO_DISPLAY_NAME[p]}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="flex items-center justify-between">
        <Text type="P2">All Managers</Text>
        <Select
          value={allManagersSelection}
          onValueChange={(val) =>
            onSetAllManagersSelection(val as SharingPermission)
          }
          disabled={disabled}
        >
          <SelectTrigger className="w-[120px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {managerOptions.map((p) => (
              <SelectItem key={p} value={p}>
                {PERMISSION_TO_DISPLAY_NAME[p]}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default GeneralAccessSection;
